import type { ApiResolver } from '@schibsted-nmp/advertising-shared';

import type { globalPropertyName } from './Resolver.js';

import type { Api } from './index.js';

export type Window = { [globalPropertyName]?: Api };

export namespace Window {
  export type AsUninitialized = ApiResolver.Window.AsUninitialized<
    Window,
    typeof globalPropertyName,
    Api.Uninitialized
  >;

  export type AsInitialized = ApiResolver.Window.AsInitialized<
    Window,
    typeof globalPropertyName,
    Api.Uninitialized,
    Api.Initialized,
    Api.Loaded
  >;
}
